import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const empty = { code: "", discount_type: "percent", discount_value: 10, min_order_amount: 0, max_discount: null, active: true };

export default function AdminCoupons() {
    const [items, setItems] = useState([]);
    const [editing, setEditing] = useState(null);
    const [open, setOpen] = useState(false);
    const load = async () => setItems((await api.get("/admin/coupons")).data);
    useEffect(() => { load(); }, []);
    const save = async () => {
        try {
            const p = { ...editing, discount_value: Number(editing.discount_value), min_order_amount: Number(editing.min_order_amount), max_discount: editing.max_discount ? Number(editing.max_discount) : null };
            if (editing.id) await api.put(`/admin/coupons/${editing.id}`, p);
            else await api.post("/admin/coupons", p);
            toast.success("Saved"); setOpen(false); load();
        } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    };
    const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/coupons/${id}`); load(); };
    return (
        <div data-testid="admin-coupons">
            <div className="flex items-center justify-between mb-6">
                <h1 className="font-display text-4xl tracking-tighter">Coupons</h1>
                <button onClick={() => { setEditing({...empty}); setOpen(true); }} className="bg-black text-white px-4 py-2 font-mono text-xs uppercase" data-testid="new-coupon-btn">+ New Coupon</button>
            </div>
            <div className="bg-white border-2 border-black">
                <table className="w-full text-sm">
                    <thead className="border-b-2 border-black"><tr className="font-mono text-[10px] uppercase text-left"><th className="p-3">Code</th><th className="p-3">Type</th><th className="p-3">Value</th><th className="p-3">Min Order</th><th className="p-3">Active</th><th className="p-3"></th></tr></thead>
                    <tbody>
                        {items.map(c => (
                            <tr key={c.id} className="border-b border-neutral-200">
                                <td className="p-3 font-mono">{c.code}</td>
                                <td className="p-3 font-mono text-xs">{c.discount_type}</td>
                                <td className="p-3 font-mono">{c.discount_type === "percent" ? `${c.discount_value}%` : `₹${c.discount_value}`}</td>
                                <td className="p-3 font-mono">₹{c.min_order_amount}</td>
                                <td className="p-3 font-mono text-xs">{c.active ? "Yes" : "No"}</td>
                                <td className="p-3 text-right">
                                    <button onClick={() => { setEditing({...c}); setOpen(true); }} className="mr-3 underline text-xs">Edit</button>
                                    <button onClick={() => del(c.id)} className="underline text-xs">Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="border-2 border-black">
                    <DialogHeader><DialogTitle className="font-display text-2xl">{editing?.id ? "Edit" : "New"} Coupon</DialogTitle></DialogHeader>
                    {editing && (
                        <div className="space-y-3">
                            <input placeholder="CODE" value={editing.code} onChange={e => setEditing({...editing, code: e.target.value.toUpperCase()})} className="w-full border-2 border-black p-2 font-mono text-sm uppercase" data-testid="coupon-code" />
                            <select value={editing.discount_type} onChange={e => setEditing({...editing, discount_type: e.target.value})} className="w-full border-2 border-black p-2 font-mono text-sm">
                                <option value="percent">Percent (%)</option>
                                <option value="flat">Flat (₹)</option>
                            </select>
                            <input type="number" placeholder="Discount value" value={editing.discount_value} onChange={e => setEditing({...editing, discount_value: e.target.value})} className="w-full border-2 border-black p-2 font-mono text-sm" data-testid="coupon-value" />
                            <input type="number" placeholder="Min order amount" value={editing.min_order_amount} onChange={e => setEditing({...editing, min_order_amount: e.target.value})} className="w-full border-2 border-black p-2 font-mono text-sm" />
                            <input type="number" placeholder="Max discount (percent only)" value={editing.max_discount || ""} onChange={e => setEditing({...editing, max_discount: e.target.value})} className="w-full border-2 border-black p-2 font-mono text-sm" />
                            <label className="flex items-center gap-2"><input type="checkbox" checked={editing.active} onChange={e => setEditing({...editing, active: e.target.checked})} /> <span className="font-mono text-xs uppercase">Active</span></label>
                        </div>
                    )}
                    <DialogFooter><button onClick={save} className="bg-black text-white px-4 py-2 font-mono text-xs uppercase" data-testid="save-coupon-btn">Save</button></DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
}
